import {connect} from 'react-redux';
import CommissionBankAccountFormView from '../../components/views/mx/CommissionBankAccountFormView';
import {State} from '../../../../types/mx/reducers';
import {AnyAction, Dispatch} from 'redux';
import * as ModalActions from '../../../../../wizard/actions/ModalActions';
import {FormFieldProps} from '../../../../../common/types/components';
import {
    CommissionBankAccountFormDispatchProps,
    CommissionBankAccountFormStateProps
} from '../../../../group/types/mx/containers';
import {Catalog} from '../../../../../common/types/common';
import * as CommissionBankAccountFormActions from '../../actions/mx/CommissionBankAccountActions';

import {
    CommissionBankAccountFile,
    BankAccountFileType,
} from '../../../../group/types/mx/types';
import {GroupState as GeneralGroupState} from '../../../../group/types/mx/reducers';
import {uniqueArray} from '../../../../../common/utils/ArrayUtils';
import {CommissionBankAccountInformationViewFieldErrorState, CommissionBankAccountState} from '../../types/mx/reducers';
import {getSafe} from '../../../../../common/utils/GeneralUtils';
import {EMPTY_CATALOG} from '../../../../constants/GlobalConstants';

const mapStateToProps = (state: State, ownProps): CommissionBankAccountFormStateProps => {
    const commissionBankAccount: CommissionBankAccountState =
        state.creditoReal.loan.loanApplication.commissionBankAccountInformation;
    const group: GeneralGroupState = state.group;
    const bankAccountSelected: Catalog = getSafe(() => commissionBankAccount.bank) || EMPTY_CATALOG;
    const bankAccountFieldError: CommissionBankAccountInformationViewFieldErrorState =
        state.creditoReal.loan.ui.commissionBankAccountDataView.fieldErrors;
    const banksCatalog: Catalog[] = group.catalogs.banks;
    const banksAccountList:Catalog[] =
        !!bankAccountSelected.value ? banksCatalog.concat(bankAccountSelected) : banksCatalog;
    return {
        banksList: uniqueArray(banksAccountList),
        bankSelected: new FormFieldProps(bankAccountSelected, bankAccountFieldError.bankFieldError),
        accountNumber: new FormFieldProps(
            commissionBankAccount.accountNumber, bankAccountFieldError.accountNumberFieldError
        ),
        beneficiaryName: new FormFieldProps(commissionBankAccount.beneficiaryName,
            bankAccountFieldError.beneficiaryNameFieldError),
        clabe: new FormFieldProps(commissionBankAccount.clabe, bankAccountFieldError.clabeFieldError),
        dealerAccountStatusFile: new FormFieldProps(commissionBankAccount.dealerAccountStatusFile,
            bankAccountFieldError.dealerAccountStatusFileFieldError),
        dealerOfficialIdentificationFile: new FormFieldProps(commissionBankAccount.dealerOfficialIdentificationFile,
            bankAccountFieldError.dealerOfficialIdentificationFileFieldError),
        createAt: commissionBankAccount.createdAt,
        loadExistCommissionBankAccount: commissionBankAccount.loadExistCommissionBankAccount
    };
};

const mapDispatchToProps = (dispatch: Dispatch<AnyAction>): CommissionBankAccountFormDispatchProps => {
    return {
        onChangeAccountNumber: (accountNumber: string, error: string) => {
            dispatch(CommissionBankAccountFormActions.CHANGE_COMMISSION_BANK_ACCOUNT_NUMBER_ACTION.action(
                accountNumber, error
            ));
        },
        onChangeBank: (bank: Catalog, error: string) => {
            dispatch(CommissionBankAccountFormActions.CHANGE_COMMISSION_BANK_ACTION.action(bank, error));
        },
        onChangeBeneficiary: (beneficiary: string, error: string) => {
            dispatch(CommissionBankAccountFormActions.CHANGE_COMMISSION_BENEFICIARY_ACTION.action(beneficiary, error));
        },
        onChangeClabe: (clabe: string, error: string) => {
            dispatch(CommissionBankAccountFormActions.CHANGE_COMMISSION_CLABE_ACTION.action(clabe, error));
        },
        onDropFileAccount: (file: CommissionBankAccountFile, error: string) => {
            dispatch(CommissionBankAccountFormActions.DROP_COMMISSION_FILE_ACCOUNT_ACTION.action(file, error));
        },
        onDropFileIdentification: (file: CommissionBankAccountFile, error: string) => {
            dispatch(CommissionBankAccountFormActions.DROP_COMMISSION_FILE_IDENTIFICATION_ACTION.action(file, error));
        },
        onDeleteFile: (fileId: string, fileType: BankAccountFileType, error: string) => {
            dispatch(CommissionBankAccountFormActions.DELETE_COMMISSION_FILE_SUCCESS_ACTION.action(
                fileId, fileType, error
            ));
        },
        onCancel: () => {
            dispatch(ModalActions.CLOSE_MODAL_ACTION.action());
        },
        onSave: () => {
            dispatch(CommissionBankAccountFormActions.COMMISSION_BANK_ACCOUNT_SAVE_ACTION.action());
        }
    };
};

const CommissionBankAccountFormContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(CommissionBankAccountFormView);

export default CommissionBankAccountFormContainer;